const service = {};
const privateState = {
  chatCenterFunctions: {},
  chatBoxFunctions: {},
};
service.attachChatCenterListener = (functionName, func) => {
  privateState.chatCenterFunctions[functionName] = func;
};
service.detachChatCenterListener = (functionName) => {
  delete privateState.chatCenterFunctions[functionName];
};
service.attachChatBoxListener = (functionName, func) => {
  privateState.chatBoxFunctions[functionName] = func;
};
service.detachChatBoxListener = (functionName) => {
  delete privateState.chatBoxFunctions[functionName];
};
service.sendNewCallRecording = (callRecordingDto, chatMessageId) => {
  return (
    privateState.chatBoxFunctions &&
    privateState.chatBoxFunctions.doWhenNewCallRecording &&
    privateState.chatBoxFunctions.doWhenNewCallRecording(
      callRecordingDto,
      chatMessageId,
    )
  );
};
service.sendStopCallRecording = () => {
  return (
    privateState.chatBoxFunctions &&
    privateState.chatBoxFunctions.doWhenStopCallRecording &&
    privateState.chatBoxFunctions.doWhenStopCallRecording()
  );
};

export default service;
